"use client";

import { FunctionComponent } from "react";

import Badge from "@/components/design-system/badge";

import styles from "./boughtThisMonth.module.scss";

const BoughtThisMonth: FunctionComponent<BoughtThisMonthProps> = ({
  isMobile = false,
  productDetails,
}: BoughtThisMonthProps) => {
  if (productDetails && productDetails.formattedQuantitySold != null) {
    return (
      <div className={isMobile ? styles.boughtThisMonthMobile : styles.boughtThisMonth}>
        <Badge
          color="yellow"
          strong={false}
          showIcon={false}
          size="small"
          label={`${productDetails.formattedQuantitySold} bought this past month`}
        />
      </div>
    );
  } else {
    return null;
  }
};

type BoughtThisMonthProps = {
  /**
   * This componet is placed in the product page two times, one for mobile and one for desktop but they have different position in the page
   * so we need to know if the component is in mobile or desktop to apply the correct style
   */
  isMobile?: boolean;
  productDetails: ProductDetails;
};

export default BoughtThisMonth;
